import React from "react";
import { useNavigate } from "react-router-dom";
import SEOHead from "../components/SEOHead";
import { Link } from "react-router-dom";
import { getAuth } from "firebase/auth";

function AIResumeBuilder() {
  const navigate = useNavigate();
  const auth = getAuth();

  const handleStart = () => {
    if (auth.currentUser) {
      navigate("/");
    } else {
      navigate("/get-started");
    }
  };

  const handleDirectStart = () => {
  if (auth.currentUser) {
    navigate("/");
  } else {
    navigate("/auth"); // 🔥 DIRECT TO SIGNUP
  }
};

  return (
    <div style={{ padding: "40px", maxWidth: "900px", margin: "0 auto" }}>

      {/* SEO META */}

      <SEOHead
        title="AI Resume Builder"
        description="Create a professional resume in minutes with EmployPilot's AI resume builder. Get ATS-optimized resumes, instant feedback, and land more interviews."
        canonical="https://employpilot.com/ai-resume-builder"
      />


      {/* HERO */}
      <h1 style={{ fontSize: "32px", marginBottom: "15px" }}>
        AI Resume Builder That Helps You Get Hired Faster
      </h1>

      <p style={{ fontSize: "18px", color: "#555", marginBottom: "30px" }}>
        Build a professional, ATS-optimized resume in minutes using AI.
        Get real-time feedback, improve your chances of getting interviews,
        and stand out in today’s competitive job market.
      </p>

      <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
        <button onClick={handleDirectStart} style={btnPrimary}>
          Build Resume in 2 Minutes — Free
        </button>

        <button
          onClick={handleStart}
          style={{
            ...btnPrimary,
            backgroundColor: "#6c757d"
          }}
        >
          See How It Works
        </button>
      </div>

      {/* SECTION 1 */}
      <h2>Why Use an AI Resume Builder?</h2>

      <p style={{ color: "#444" }}>
        Most resumes fail before they even reach a hiring manager.
        Applicant Tracking Systems (ATS) filter candidates automatically.
        EmployPilot’s AI resume builder helps you create resumes that pass
        these systems and impress recruiters.
      </p>

      <ul>
        <li>✔ ATS-optimized formatting</li>
        <li>✔ AI-generated professional summaries</li>
        <li>✔ Role-specific resume tailoring</li>
        <li>✔ Instant resume feedback</li>
      </ul>

      {/* SECTION 2 */}
      <h2 style={{ marginTop: "40px" }}>
        How EmployPilot’s AI Resume Builder Works
      </h2>

      <p style={{ color: "#444" }}>
        Our system analyzes your experience, skills, and job goals to generate
        a customized resume that aligns with real hiring expectations.
      </p>

      <ol>
        <li>Enter your experience and career goals</li>
        <li>Generate your AI-powered resume</li>
        <li>Download your resume as a PDF</li>
        <li>Improve with feedback and updates</li>
      </ol>

      <div style={{
        marginTop: "40px",
        padding: "20px",
        background: "#f8f9fa",
        borderRadius: "10px",
        textAlign: "center"
      }}>
        <h3>Ready to build your resume?</h3>

        <button onClick={handleDirectStart} style={btnPrimary}>
          Start Free — No Credit Card
        </button>

        <p style={{ marginTop: "10px", fontSize: "14px", color: "#666" }}>
          Takes less than 2 minutes.
        </p>
      </div>

      <p style={{ marginTop: "15px" }}>
        Preparing for interviews next?{" "}
        <Link to="/ai-interview-coach">
          Practice with our AI Interview Coach
        </Link>
      </p>

      {/* SECTION 3 */}
      <h2 style={{ marginTop: "40px" }}>
        Built for Real Job Seekers — Not Templates
      </h2>

      <p style={{ color: "#444" }}>
        Unlike generic resume tools, EmployPilot adapts to your career path.
        Whether you're switching careers, applying for your first job, or
        leveling up, our platform helps you present your experience clearly
        and confidently.
      </p>

      {/* CTA */}
      <div style={{ marginTop: "50px", textAlign: "center" }}>
        <h2>Start Building Your Resume Today</h2>

        <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "14px",
          marginTop: "20px",
          flexWrap: "wrap"
        }}
      ></div>

       <button onClick={handleDirectStart} style={btnSuccess}>
      Start Free Now
      </button>

        <button
      onClick={handleStart}
      style={{
        ...btnSuccess,
        backgroundColor: "#adb5bd" // softer gray (better hierarchy)
      }}
    >
      Learn More First
    </button>
      </div>
<div
    style={{
      marginTop: "80px",
      textAlign: "center",
      fontSize: "14px",
      color: "#777",
      borderTop: "1px solid #eee",
      paddingTop: "30px"
    }}
  >
    © 2026 EmployPilot. All Rights Reserved.

    <div style={{ marginTop: "10px" }}>
      <a href="/terms" style={{ margin: "0 10px" }}>
        Terms of Use
      </a>

      <a href="/privacy" style={{ margin: "0 10px" }}>
        Privacy Policy
      </a>

      <a href="/contact" style={{ margin: "0 10px" }}>
        Contact
      </a>
    </div>
  </div>
</div>
  );
}

const btnPrimary = {
  backgroundColor: "#007bff",
  color: "#fff",
  padding: "12px 20px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  fontSize: "16px",
  marginBottom: "40px"
};

const btnSuccess = {
  backgroundColor: "#28a745",
  color: "#fff",
  padding: "14px 24px",
  borderRadius: "8px",
  border: "none",
  cursor: "pointer",
  fontSize: "18px"
};

export default AIResumeBuilder;